import React from 'react';
import PropTypes from 'prop-types';
import { priorities } from '../../project/Defines';


export const PriorityBlock = ({ priority }) => {
    const priorityItem = priorities.find(p => p.id === priority);

    return priorityItem ? <status data="" priority={priorityItem.text.toLowerCase()}
    > {/* medium high' low*/}
        <text data-weight="500" light=""
        >{priorityItem.text}</text>
        <icon>{priorityItem.arrow}</icon>
    </status> : <></>;

}

PriorityBlock.propTypes = {
    priority: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};